import React from "react";
import theme from "app/Theme/Theme";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CrossIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="m17.77 5.506-4.87 4.87-4.87-4.87a1.148 1.148 0 1 0-1.624 1.623L11.276 12l-4.87 4.87a1.148 1.148 0 1 0 1.623 1.624l4.871-4.87 4.87 4.87a1.148 1.148 0 1 0 1.625-1.623L14.524 12l4.87-4.87a1.148 1.148 0 0 0-1.623-1.624Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path
          fill={theme.colors["neutral.white"]}
          transform="translate(.9)"
          d="M0 0h24v24H0z"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default CrossIcon;
